import { withRouter } from 'react-router';
import { connectLean } from 'lean-redux';
import { connect } from 'react-redux';
import { compose } from 'react-apollo';
import dayjs from 'dayjs';
import Button from 'chameleon/ui-stack/ui/base/button';
import { Icon } from 'legacy-packages/ft-cb';
import AssignmentOpen from 'chameleon-src/utility/assignmentOpen';
import IsMobileDevice from 'legacy-src/utility/isMobile';
import IsLdbEnabled from 'legacy-src/utility/IsLdbEnabled';
import { SubunitAssessmentTypes } from 'legacy-packages/unit-outline/src/constants';
import TimedAssignmentWarningModal from 'chameleon/ui-stack/ui/assignments/timed-assignment-warning-modal';
import { displayDigitalAssessmentInfoModal } from 'legacy/src/components/assessment/DigitalAssessmentInfoModal/utils';
import DigitalAssessmentInfoModal from 'legacy/src/components/assessment/DigitalAssessmentInfoModal';
import StudentSingleAssignmentProgress from './components/progress-bar/StudentSingleAssignmentProgress';
import ProgressChecks from './ProgressChecks';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import React, { Fragment, useState, useRef } from 'react';
import StudentViewAll from '../StudentViewAll';
import { getStatusActions } from './utils';
import { openSecureBrowserLink } from 'chameleon/legacy/src/components/apstudent/handlers/Assignments/lockdownbrowser';

const GET_FEEDBACK = 'GET FEEDBACK';

const StudentProgressChecks = (props) => {
  const actionButtonRef = useRef({});
  const {
    unitId,
    resources,
    unitsStatuses = {},
    params,
    router,
    location,
    userData: {
      me: { initId: studentId, preferences: userPreferences = {} },
    },
    userSubjects,
    featureFlag,
    isPreApSubject,
    unitDisplayName,
    subunitType = SubunitAssessmentTypes.PPC,
    subjectData,
    secureAssignmentIds,
  } = props;
  const { bluebook_ui: bluebookUIFF } = featureFlag;
  const [showTimedAssignmentModal, setShowTimedAssignmentModal] =
    useState(false);
  const assignmentOverview = useRef({});
  const [secureAssessmentOnMobile, setSecureAssessmentOnMobile] =
    useState(false);
  const [digitalAssessmentInfoModalOpen, setDigitalAssessmentInfoModalOpen] =
    useState(false);
  const [digitalAssessmentModalCB, setDigitalAssessmentModalCB] = useState(
    () => () => {},
  );
  const resourceStatuses = get(unitsStatuses, `unit-${unitId}.resources`, {});
  const { subject } = params;
  const { pathname, search } = location;
  const returnPath = `${pathname}${search}`;
  const isLdbEnabled = IsLdbEnabled(
    featureFlag.secure_browser,
    featureFlag.secure_browser_preap,
    isPreApSubject,
  );
  const isMobileDevice = IsMobileDevice();

  const assignOpen = new AssignmentOpen(
    { ...props, isLdbEnabled, isMobileDevice },
    setSecureAssessmentOnMobile,
  );

  const getAssignmentOverview = (resourceId) => {
    const { assignmentOverview } =
      resourceStatuses[`resource-${resourceId}-subject-${subject}`] || {};

    return assignmentOverview;
  };

  const getAssignmentUrl = (assignment) => {
    if (assignment) {
      const { canOpenAssignment, canSeeResults, canScore } =
        getStatusActions(assignment);
      const { id: assignmentId } = assignment || {};
      if (canOpenAssignment) {
        const { link } = assignment;
        return {
          pathname: `/${link}`,
          state: {
            returnPath,
          },
        };
      } else if (canSeeResults) {
        return {
          pathname: `/${subject}/assessments/results/${assignmentId}`,
          state: { returnPath },
        };
      } else if (canScore) {
        return {
          pathname: `/score/${assignmentId}/students/${studentId}`,
          query: {
            returnPath,
          },
        };
      }
    }
  };

  const shouldDisplayDigitalAssessmentInfoModal =
    displayDigitalAssessmentInfoModal({
      subject: router.params.subject,
      bluebookUIFF,
      userPreferences,
      userSubjects,
      isStudent: true,
      subjectData,
    });

  const assignmentOnClick = (callback) => {
    if (shouldDisplayDigitalAssessmentInfoModal) {
      setDigitalAssessmentInfoModalOpen(true);
      setDigitalAssessmentModalCB(() => callback);
    } else {
      callback();
    }
  };

  const getSingleAssignmentAction = (assignment) => {
    const { headline, link, id: assignmentId } = assignment || {};
    const {
      canOpenAssignment,
      isNoActionSubmitted,
      isNoActionAwaitingScoring,
      isNoActionPaperTest,
      isNoActionNoResults,
      isMCQAwaitingScoring,
      canSeeResults,
      hasNoActionLocked,
      canScore,
      isBeginTimerAssignment,
    } = getStatusActions(assignment);

    let actionButton;
    if (canOpenAssignment) {
      const getClickAction = () => {
        let clickAction = () => {
          const secureLink = secureAssignmentIds[Number(assignmentId)];
          if (secureLink && isLdbEnabled && headline !== GET_FEEDBACK) {
            if (isMobileDevice) {
              setSecureAssessmentOnMobile(true);
            } else {
              openSecureBrowserLink(secureLink, () => {});
            }
          } else {
            router.push({ pathname: `/${link}`, state: { returnPath } });
          }
        };

        if (isBeginTimerAssignment) {
          clickAction = () => beginTimerAssignment(assignment);
        }
        return clickAction;
      };

      const buttonAction = getClickAction();

      actionButton = (
        <Button isPrimary onClick={() => assignmentOnClick(buttonAction)}>
          {headline === 'BEGIN' ? 'Begin' : 'Continue'}
        </Button>
      );
    } else if (isMCQAwaitingScoring) {
      actionButton = 'Awaiting Scoring';
    } else if (isNoActionSubmitted) {
      actionButton = 'Submitted';
    } else if (isNoActionAwaitingScoring) {
      actionButton = 'Awaiting Scoring';
    } else if (isNoActionNoResults) {
      actionButton = 'Results not made available by teacher';
    } else if (canSeeResults) {
      actionButton = (
        <StudentSingleAssignmentProgress key={unitId} assignment={assignment} />
      );
    } else if (canScore) {
      actionButton = (
        <Button
          isPrimary
          onClick={() => {
            router.push({
              pathname: `/score/${assignmentId}/students/${studentId}`,
              query: {
                returnPath,
              },
            });
          }}
        >
          Score
        </Button>
      );
    } else if (hasNoActionLocked) {
      actionButton = (
        <div className="font-content text-black">
          <Icon name="locked" role="presentation" /> Locked
        </div>
      );
    } else if (isNoActionPaperTest) {
      actionButton = 'Print Format';
    }

    return typeof actionButton === 'string' ? (
      <span className="font-normal font-content text-black italic">
        {actionButton}
      </span>
    ) : (
      actionButton
    );
  };

  const getResourceActions = (resource) => {
    const { resourceId, displayName } = resource || {};
    const assignmentOverview = getAssignmentOverview(resourceId);

    if (assignmentOverview) {
      const { assignments, assessmentId } = assignmentOverview;

      if ((assignments || []).length === 0) {
        return null;
      }

      if ((assignments || []).length > 1) {
        const sortedByCreatedAt = assignments.sort(
          (
            { assignmentCreatedAt: assignmentCreatedAt_A },
            { assignmentCreatedAt: assignmentCreatedAt_B },
          ) => {
            if (dayjs(assignmentCreatedAt_A).isBefore(assignmentCreatedAt_B)) {
              return -1;
            }

            if (dayjs(assignmentCreatedAt_B).isBefore(assignmentCreatedAt_A)) {
              return 1;
            }

            return 0;
          },
        );

        return (
          <StudentViewAll
            header={displayName}
            assessmentId={assessmentId}
            assignments={sortedByCreatedAt}
            getSingleAssignmentAction={getSingleAssignmentAction}
            actionButtonRef={actionButtonRef}
          />
        );
      }

      const assignment = assignments[0];
      return getSingleAssignmentAction(assignment, displayName);
    }
  };

  const beginTimerAssignment = (assignment) => {
    const assignmentStatus = assignOpen.onTimedAssessmentClick(
      assignment,
      assignment.headline === 'BEGIN',
      featureFlag.cb_session_expiration_check_before_take_assignment,
      featureFlag.cb_session_expiration_override,
      featureFlag.levity_use_createtime,
      secureAssessmentOnMobile,
    );
    if (assignmentStatus.isTimedAssignment) {
      setShowTimedAssignmentModal(true);
      assignmentOverview.current = assignment;
    }
  };

  const onResourceClicked = (assignment, url) => {
    const { isBeginTimerAssignment } = getStatusActions(assignment);

    if (isBeginTimerAssignment) {
      beginTimerAssignment(assignment);
      return;
    }

    router.push(url);
  };

  const onModalSuccess = () => {
    assignOpen.beginAssignment(
      assignmentOverview.current,
      `${location.pathname}${location.search}`,
    );
  };

  const onModalClose = () => {
    setShowTimedAssignmentModal(false);
    assignmentOverview.current = {};
  };

  return (
    <Fragment>
      {showTimedAssignmentModal ? (
        <TimedAssignmentWarningModal
          onSuccess={onModalSuccess}
          onClose={onModalClose}
          timer={assignmentOverview.current.timer}
        />
      ) : null}
      {shouldDisplayDigitalAssessmentInfoModal &&
        digitalAssessmentInfoModalOpen && (
          <DigitalAssessmentInfoModal
            onClose={() => setDigitalAssessmentInfoModalOpen(false)}
            onSubmit={digitalAssessmentModalCB}
          />
        )}
      <ProgressChecks
        getAssignmentUrl={getAssignmentUrl}
        getResourceActions={getResourceActions}
        onResourceClicked={onResourceClicked}
        resources={resources}
        unitDisplayName={unitDisplayName}
        subunitType={subunitType}
      />
    </Fragment>
  );
};

StudentProgressChecks.propTypes = {
  unitId: PropTypes.string.isRequired,
  resources: PropTypes.array.isRequired,
};

const mapStateToProps = ({
  userData,
  userSubjects,
  subject: { data: subjectData },
  featureFlag,
  secureAssignmentIds,
}) => ({
  userData,
  userSubjects,
  featureFlag,
  isPreApSubject: subjectData.isPreApSubject,
  subjectData,
  secureAssignmentIds,
});

export default compose(
  withRouter,
  connect(mapStateToProps),
  connectLean({
    scope: 'units',
    mapState(state) {
      return {
        unitsStatuses: {
          ...state,
        },
      };
    },
  }),
)(StudentProgressChecks);
